// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__20hA3","insightsList":"newBusinessInsightsMenu_insightsList__FjCMi","active":"newBusinessInsightsMenu_active__188NA"};